import mapKnownValues from "@/utils/mapKnownValues";

export type ADREventResponse = {
  id: string;
  signalName: string;
  signalType: string;
  level: number;
  startTime: string; // date
  durationSeconds: number;
  description: string;
  createdAt: string; // date
};

export default class ADREvent {
  id = "";
  signalName = "";
  signalType = "";
  level = 0;
  startTime = new Date();
  durationSeconds = 0;
  description = "";
  createdAt = new Date();

  constructor(params: Partial<ADREvent> = {}) {
    mapKnownValues(this, params);
  }

  static fromAPI(response: ADREventResponse) {
    return new ADREvent({
      ...response,
      startTime: new Date(response.startTime),
      createdAt: new Date(response.createdAt)
    });
  }
}
